var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMilitary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 44,
    viewBox: "0 0 55 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_1139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6948 6.98592L27.2564 4.36548L32.3406 6.98592C32.3406 6.98592 33.2791 14.6448 27.3395 16.36C27.3395 16.36 21.7742 14.4423 22.6948 6.98592Z",
    fill: "#02F3A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9245 32.9642L54.3764 22.6193L48.128 10.1185L27.1853 0.577637L6.24843 10.1185L0.611816 22.0357L8.93903 32.9642",
    stroke: "#7829FA",
    strokeWidth: 1.77,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.506 43.47C38.6328 43.47 47.6529 40.8836 47.6529 37.6931C47.6529 34.5026 38.6328 31.9161 27.506 31.9161C16.3792 31.9161 7.35913 34.5026 7.35913 37.6931C7.35913 40.8836 16.3792 43.47 27.506 43.47Z",
    stroke: "#7829FA",
    strokeWidth: 1.77,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97473 35.4239C8.9227 34.4202 9.12714 33.4198 9.56869 32.5176C10.7566 29.9626 14.2312 26.5977 24.1383 26.2701C40.2998 25.7341 47.0352 30.308 46.0255 35.4239",
    stroke: "#7829FA",
    strokeWidth: 1.77,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58056 32.5176C9.58056 32.5176 6.91372 27.9974 10.5665 25.3233C14.2193 22.6492 22.9683 20.0942 30.7253 20.8685C38.4823 21.6427 49.1734 23.3758 45.8651 32.8631",
    stroke: "#7829FA",
    strokeWidth: 1.77,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_1139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 44,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilitary);
export default __webpack_public_path__ + "static/media/military.63f8a7d2ed1c2d50c76f1c0f0a21047e.svg";
export { ForwardRef as ReactComponent };